var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"platform"}},[_c('img',{ref:"platformImg",staticClass:"platform",attrs:{"src":require("../assets/platform.png"),"alt":"The games platform"}})])}
var staticRenderFns = []

export { render, staticRenderFns }